import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import services from '../../services';

// Define initial state
const initialState = {
  one: {
    data: null,
    loading: false,
    error: false,
    success: false
  },
  create: {
    data: null,
    loading: false,
    error: false,
    success: false
  },
  all: {
    data: null,
    loading: false,
    error: false,
    success: false
  },
  update: {
    data: null,
    loading: false,
    error: false,
    success: false
  },
};

// Async action to get one bank account
const getOneBankAccount = createAsyncThunk(
  'bankAccount/getOne',
  async (payload) => {
    console.log('get one - bank account - action', payload)
    const { response, error } = await services.bankAccount.getOne(payload);
    if (error) {
      throw new Error(error);
    }
    return response;
  }
);

// Async action to get all bank accounts
const getAllBankAccounts = createAsyncThunk(
  'bankAccount/getAll',
  async (payload) => {
    console.log('get all - bank account - action', payload)
    const { response, error } = await services.bankAccount.getAll(payload);
    if (error) {
      throw new Error(error);
    }
    return response;
  }
);

// Async action to create one bank account
const createOneBankAccount = createAsyncThunk(
  'bankAccount/createOne',
  async (payload) => {
    console.log('create one - bank account - action', payload)
    const { response, error } = await services.bankAccount.createOne(payload);
    if (error) {
      throw new Error(error);
    }
    return response;
  }
);

// Async action to update a bank account
const updateBankAccount = createAsyncThunk(
  'bankAccount/update',
  async (payload) => {
    console.log('update - bank account - action', payload)
    const { response, error } = await services.bankAccount.update(payload);
    if (error) {
      throw new Error(error);
    }
    return response;
  }
);

// Create a bank account slice
const bankAccountSlice = createSlice({
  name: 'bankAccount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOneBankAccount.pending, (state) => {
        state.one.data = null;
        state.one.loading = true;
        state.one.success = false;
        state.one.error = false;
      })
      .addCase(getOneBankAccount.fulfilled, (state, action) => {
        state.one.data = action.payload;
        state.one.loading = false;
        state.one.success = true;
        state.one.error = false;
      })
      .addCase(getOneBankAccount.rejected, (state, action) => {
        state.one.data = null;
        state.one.loading = false;
        state.one.success = false;
        state.one.error = action.error.message;
      })
      .addCase(getAllBankAccounts.pending, (state) => {
        state.all.data = null;
        state.all.loading = true;
        state.all.success = false;
        state.all.error = false;
      })
      .addCase(getAllBankAccounts.fulfilled, (state, action) => {
        state.all.data = action.payload;
        state.all.loading = false;
        state.all.success = true;
        state.all.error = false;
      })
      .addCase(getAllBankAccounts.rejected, (state, action) => {
        state.all.data = null;
        state.all.loading = false;
        state.all.success = false;
        state.all.error = action.error.message;
      })
      .addCase(createOneBankAccount.pending, (state) => {
        state.create.data = null;
        state.create.loading = true;
        state.create.success = false;
        state.create.error = false;
      })
      .addCase(createOneBankAccount.fulfilled, (state, action) => {
        state.create.data = action.payload;
        state.create.loading = false;
        state.create.success = true;
        state.create.error = false;
        state.one.data = action.payload;
      })
      .addCase(createOneBankAccount.rejected, (state, action) => {
        state.create.data = null;
        state.create.loading = false;
        state.create.success = false;
        state.create.error = action.error.message;
      })
      .addCase(updateBankAccount.pending, (state) => {
        state.update.data = null;
        state.update.loading = true;
        state.update.success = false;
        state.update.error = false;
      })
      .addCase(updateBankAccount.fulfilled, (state, action) => {
        state.update.data = action.payload;
        state.update.loading = false;
        state.update.success = true;
        state.update.error = false;
      })
      .addCase(updateBankAccount.rejected, (state, action) => {
        state.update.data = null;
        state.update.loading = false;
        state.update.success = false;
        state.update.error = action.error.message;
      });
  },
});

// Export the async actions and the reducer
export { getOneBankAccount, getAllBankAccounts, createOneBankAccount, updateBankAccount };
export default bankAccountSlice.reducer;